import { Button } from "@src/components/atoms";
import { CardContainer } from "@src/components/cards";
import { CustomerForm } from "@src/components/forms/admin/CustomerForm";
import { CUSTOMER_LOGO_URL, NO_IMAGE_FOUND } from "@src/constants/constants";
import { dateFormatterUTC } from "@src/constants/convertions";
import moment from "moment";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const MainDetailsSection = ({ data }) => {
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {isEditing ? (
        <div className="p-4">
          <div className="text-center text-red-500 mb-4">
            You are editing customer details. Make sure to save your changes
            before navigating away.
          </div>
          <CustomerForm
            data={data}
            onSubmit={() => {
              setIsEditing(false);
              navigate(0);
            }}
          />
        </div>
      ) : (
        <div className="px-4 pb-4">
          <CardContainer padding={4}>
            <div className="px-4">
              <div className="flex mb-4">
                <div className="px-2">
                  <img
                    className="h-8 w-auto mx-auto"
                    src={CUSTOMER_LOGO_URL(data.customerCode)}
                    alt={data.customerCode}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = NO_IMAGE_FOUND;
                    }}
                  />
                </div>
                <h3 className="mb-2">{data.name}</h3>
              </div>
              {Object.entries(data).map(([key, value], index) => {
                const result = key.includes("Date")
                  ? dateFormatterUTC(value)
                  : Array.isArray(value)
                    ? value.length
                    : String(value);

                return (
                  <div key={key} className="flex ">
                    <div className="min-w-64 font-bold">{key}</div>
                    <div>{result}</div>
                  </div>
                );
              })}
            </div>
            <div className="w-48">
              <Button
                icon={"feedback"}
                block={false}
                secondary
                onClick={setIsEditing}
              >
                Edit
              </Button>
            </div>
          </CardContainer>
        </div>
      )}
    </>
  );
};
